import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(client)/attachment-templates/')({
  component: AttachmentTemplatesPage,
});

function AttachmentTemplatesPage() {
  return (
    <div className='flex items-center justify-center flex-1'>
      <p className='text-sm text-muted-foreground'>Coming soon</p>
    </div>
  );
}
